export default "__VITE_ASSET__D813P6qo__"